/* tslint:disable */
/* eslint-disable */
/**
 * External EMR API
 * Clinical documents pulled from external EMRs (Net Health today) for a patient\'s external EHR record. Consumer-agnostic: concurrent review is the first consumer, but nothing here is re-auth specific. Routes are lead-scoped because the pull needs the lead\'s facility to resolve the Net Health consumer site; the documents themselves belong to the external EHR patient.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ExternalEmrDocumentPullStart } from './ExternalEmrDocumentPullStart';
import {
    ExternalEmrDocumentPullStartFromJSON,
    ExternalEmrDocumentPullStartFromJSONTyped,
    ExternalEmrDocumentPullStartToJSON,
    ExternalEmrDocumentPullStartToJSONTyped,
} from './ExternalEmrDocumentPullStart';

/**
 * 
 * @export
 * @interface StartExternalEmrDocumentPull201Response
 */
export interface StartExternalEmrDocumentPull201Response {
    /**
     * 
     */
    data?: ExternalEmrDocumentPullStart;
}

/**
 * Check if a given object implements the StartExternalEmrDocumentPull201Response interface.
 */
export function instanceOfStartExternalEmrDocumentPull201Response(value: object): value is StartExternalEmrDocumentPull201Response {
    return true;
}

export function StartExternalEmrDocumentPull201ResponseFromJSON(json: any): StartExternalEmrDocumentPull201Response {
    return StartExternalEmrDocumentPull201ResponseFromJSONTyped(json, false);
}

export function StartExternalEmrDocumentPull201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StartExternalEmrDocumentPull201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ExternalEmrDocumentPullStartFromJSON(json['data']),
    };
}

export function StartExternalEmrDocumentPull201ResponseToJSON(json: any): StartExternalEmrDocumentPull201Response {
    return StartExternalEmrDocumentPull201ResponseToJSONTyped(json, false);
}

export function StartExternalEmrDocumentPull201ResponseToJSONTyped(value?: StartExternalEmrDocumentPull201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ExternalEmrDocumentPullStartToJSON(value['data']),
    };
}

